import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForumService } from '../forum.service';
import { Topic } from '../topic';

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),    
    providers: [ForumService]
})

export class ForumDashboardComponent implements OnInit {    

    router: Router;
    userStatus: string;
    title: string;
    topics: Topic[];
    topicModal: any;
    topicName: string;
    topicNameError: boolean;
    classLoginModal: any;
    loginCode: number;
    loginEmail: string;
    loginPassword: string;
    classForgetPasswordModal: any;
    forgetPasswordEmail: string;   
    forgetPasswordEmailEmpty: boolean;
    forgetPasswordEmailIncorrect: boolean;
    classEmailSendedModal: any;
    emailSended: boolean;   

    constructor(private _forumService: ForumService, _parentRouter: Router) {
        this.router = _parentRouter;
        this.userStatus = "";      
        this.title = "";
        this.topics = [];
        this.topicModal = { 'model': true, 'show': false, 'hide': true };
        this.topicName = "";
        this.topicNameError = false;
        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
        this.loginCode = 0;
        this.loginEmail = "";
        this.loginPassword = "";    
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;  
        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
        this.emailSended = false;
    }

    ngOnInit() {
        
        this._forumService.getUserStatus().then(status => {
            this.userStatus = status.role;
        });

        this._forumService.getTitle().then(res => {
            if(res != null) {
                this.title = res;
            }
        });

        this._forumService.getTopics().then(res => {            
            if(res != null) {
                this.topics = res;
            }            
        });

    }    

    addNewTopic() {        
        if(this.userStatus != "guest") {
            this.topicModal.show = true;
            this.topicModal.hide = false;
        } else {
            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;
        }
    }

    closeTopicModal() {
        this.topicName = "";
        this.topicNameError = false;
        this.topicModal.show = false;
        this.topicModal.hide = true;
    }

    saveTopicModal() {
        if(this.topicName != null && this.topicName != undefined && this.topicName.length > 0) {
            this.topicNameError = false;
            this._forumService.postTopic(this.topicName).then(res => {
                if(res.code == 1) {
                    this.closeTopicModal();
                    this._forumService.getTopics().then(res => {            
                        if(res != null) {
                            this.topics = res;
                        }            
                    });
                }
            });
        } else {
            this.topicNameError = true;
        }
    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    loginClicked() {

        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {                
                localStorage.setItem('userName', result.user.name);                
                localStorage.setItem('idUser', result.user.id.toString());
                location.reload();                
            }
        });

    }

    registerClicked() {
        this.router.navigate(['/register']);
    } 

    forgetPassword() {
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
        this.classForgetPasswordModal.show = true;
        this.classForgetPasswordModal.hide = false;
    }

    closeForgetPasswordModal() {
        this.classForgetPasswordModal.show = false;
        this.classForgetPasswordModal.hide = true;
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
    }

    getPasswordByEmail() {
        if(this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
            this.forgetPasswordEmailEmpty = false;
            this._forumService.verifyEmail(this.forgetPasswordEmail).then(res => {
                if(res) {                    
                    this.forgetPasswordEmailIncorrect = false;
                    this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
                        if(res == 1) {
                            this.classForgetPasswordModal.show = false;
                            this.classForgetPasswordModal.hide = true;
                            this.forgetPasswordEmailEmpty = false;
                            this.forgetPasswordEmailIncorrect = false;

                            this.classEmailSendedModal.show = true;
                            this.classEmailSendedModal.hide = false;
                        }
                    })
                } else {
                    this.forgetPasswordEmailIncorrect = true;
                }
            });
        } else {
            this.forgetPasswordEmailEmpty = true;
        }
    }

    resendEmailRecoverPassword() {
        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {            
            if (res == 1) {                
                this.emailSended = true;
            }
        });
    }

    closeEmailSendedModal() {
        this.classEmailSendedModal.show = false;
        this.classEmailSendedModal.hide = true;
        this.forgetPasswordEmail = "";
        this.emailSended = false;

    }

    getDays(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60/24);
    }

    getHours(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/forum/dashboard/dashboard.component.ts
 **/